import { useCallback, useEffect, useState } from 'react'
import { Header } from './components/Header'
import { Hero } from './components/Hero'
import { OperatorCredibility } from './components/OperatorCredibility'
import { ArchitectureStrip } from './components/ArchitectureStrip'
import { Sizer } from './components/Sizer'
import { WhyCyLogic } from './components/WhyCyLogic'
import { WorkloadFitness } from './components/WorkloadFitness'
import { Migration } from './components/Migration'
import { Compare } from './components/Compare'
import { CapabilityStatement } from './components/CapabilityStatement'
import { TalkToUs } from './components/TalkToUs'
import { Footer } from './components/Footer'
import { LeadModal, type InquiryType } from './components/LeadModal'
import { CapabilityStatementPlaceholder } from './components/CapabilityStatementPlaceholder'

function scrollTo(id: string) {
  const el = document.getElementById(id)
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

const BOOKINGS_URL = (import.meta.env.VITE_MICROSOFT_BOOKINGS_URL as string | undefined) ?? ''

export function App() {
  const [modalOpen, setModalOpen] = useState(false)
  const [inquiryType, setInquiryType] = useState<InquiryType>('general')

  const [route, setRoute] = useState<string>(window.location.pathname)
  useEffect(() => {
    const onPop = () => setRoute(window.location.pathname)
    window.addEventListener('popstate', onPop)
    return () => window.removeEventListener('popstate', onPop)
  }, [])

  const openModal = useCallback((t: InquiryType) => {
    setInquiryType(t)
    setModalOpen(true)
  }, [])

  const onArchitectureReview = useCallback(() => {
    if (BOOKINGS_URL) {
      window.open(BOOKINGS_URL, '_blank', 'noopener,noreferrer')
    } else {
      openModal('architecture_review')
    }
  }, [openModal])

  if (route === '/capability-statement-coming-soon') {
    return (
      <CapabilityStatementPlaceholder
        onBack={() => {
          history.pushState(null, '', '/')
          setRoute('/')
        }}
      />
    )
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header onSizer={() => scrollTo('sizer')} onTalk={() => openModal('general')} />
      <Hero
        onSizeWorkload={() => scrollTo('sizer')}
        onTalkToArchitect={onArchitectureReview}
      />
      <OperatorCredibility />
      <ArchitectureStrip />
      <Sizer onJumpToCompare={() => scrollTo('compare')} />
      <WhyCyLogic />
      <WorkloadFitness />
      <Migration onScheduleAssessment={onArchitectureReview} />
      <Compare />
      <CapabilityStatement onRequest={() => openModal('capability_statement')} />
      <TalkToUs
        onCaptureTeaming={() => openModal('capture_teaming')}
        onArchitectureReview={onArchitectureReview}
      />
      <Footer
        onScrollToSizer={() => scrollTo('sizer')}
        onArchitectGpu={onArchitectureReview}
        onContact={() => openModal('general')}
        onCapStatement={() => openModal('capability_statement')}
      />

      <LeadModal
        open={modalOpen}
        defaultInquiryType={inquiryType}
        onClose={() => setModalOpen(false)}
      />
    </div>
  )
}
